/**
 * @component AdminToolbar
 * @description 편집 패널 상단에 제목·안내·저장/되돌리기 버튼을 배치하는 공용 바입니다.
 * @usage HistoryAdminPanel, FaqAdminPanel, ContentAdminPanel 에서 사용합니다.
 */

// [기능] 편집 작업과 선택적 초기화 버튼을 배치하고 진행 중 작업을 잠급니다.
export default function AdminToolbar({ title, hint, errorMessage, isSaving, isDirty, onSave, onReset, onSeedReset, isResetting = false }) {
  return (
    <div className="admin-toolbar">
      <div className="admin-toolbar-text">
        <h2 className="admin-toolbar-title">{title}</h2>
        {hint && <p className="admin-toolbar-hint">{hint}</p>}
      </div>

      <div className="admin-toolbar-actions">
        {errorMessage && <span className="admin-error">{errorMessage}</span>}
        {/* [비즈니스] 변경이 없을 때 저장/되돌리기를 막아 불필요한 전체 교체 저장을 방지합니다. 초기화는 저장된 데이터를 바꾸므로 변경 여부와 무관합니다. */}
        {typeof onSeedReset === 'function' && (
          <button type="button" className="admin-btn admin-btn-danger" onClick={onSeedReset} disabled={isSaving || isResetting}>
            초기화
          </button>
        )}
        <button type="button" className="admin-btn admin-btn-ghost" onClick={onReset} disabled={isSaving || isResetting || !isDirty}>
          되돌리기
        </button>
        <button type="button" className="admin-btn admin-btn-primary" onClick={onSave} disabled={isSaving || isResetting || !isDirty}>
          {isSaving ? '저장 중...' : '저장'}
        </button>
      </div>
    </div>
  );
}
